import * as React from 'react';

type BlogCardProps = {
  url: string;
  heading: string;
  articleAuthor: string;
  contentType: string;
  image: {
    description: string;
    png: string;
    webp: string;
  };
};

const BlogCard: React.FC<BlogCardProps> = ({
  url,
  heading,
  articleAuthor,
  contentType,
  image
}) => (
  <a href={url} className="image-card featured-item">
    <div className="picture">
      <picture>
        <source srcSet={image.webp} type="image/webp" />
        <img src={image.png} width="528" height="297" alt={image.description} />
      </picture>
    </div>
    <div className="image-card__content">
    
      <h3 className="image-card__heading">{heading}</h3>
      <p className="image-card__description">{contentType} | {articleAuthor}</p>
      {/* <p className="image-card__description">{eventType}</p>*/}  
      
    </div>
  </a>
);

export default BlogCard;
